const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
var hsID = urlParams.get("healthspanid");
if (hsID) {
  localStorage.setItem("healthspanid", hsID);
} else {
  hsID = localStorage.getItem("healthspanid");
}
let preload = document.getElementById("preloader-report");
if(preload){
  
document.getElementById("preloader-report").style.display = "flex";
setTimeout(() => {
    document.getElementById("preloader-report").style.display = "none";
}, 1500);
}


const requestOptions = {
  method: "GET",
  redirect: "follow"
};
let buyNow = document.querySelector(".plan-container .btn.btn-primary.buyNow");
console.log('buyNow :',buyNow);
let age = document.querySelector('.info-item .age');
let name = document.querySelector('.client-name .Quiz-user');
let gender = document.querySelector('.info-item .gender');
let height = document.querySelector('.info-item .height');
let bmi = document.querySelector('.info-item .bmi');
let weight = document.querySelector('.info-item .weight');
let goal_weight = document.querySelector('.info-item .goal-weight');
let activity = document.querySelector('.info-item .activity');
let preference = document.querySelector('.info-item .preference');
let bmr = document.querySelector('.vital-stats .stat-value .bmr');
let tdee = document.querySelector('.vital-stats .stat-value .tdee');
let rdc = document.querySelector('.vital-stats .stat-value .rdc');
let allergic = document.querySelector('.info-item .allergic');
let protein = document.querySelector('.macronutrient-needs .macro-value.macronutrient1');
let fat =  document.querySelector('.macronutrient-needs .macro-value.macronutrient2');
let carbs = document.querySelector('.macronutrient-needs .macro-value.macronutrient3');
let water = document.querySelector('.macronutrient-needs .macro-value.macronutrient4');

let download_report = document.querySelector('.life-con .btn-primary');
download_report.addEventListener('click',()=>{
    document.querySelector('.main-chat-box').style.display="none";
    const fullUrl = window.location.href;
    let headerbar = document.querySelector("body .shopify-section.shopify-section-group-header-group.shopify-section--header");
    headerbar.classList.add('highlight');
    const now = new Date();
    const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
    const formattedDate = now.toLocaleDateString('en-US', options).replace(',', '');
    html2canvas(document.body).then((canvas) => {
        const image = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        let filename = `report_${formattedDate}.png`;
        link.href = image;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);      
    }).catch((error) => {
        console.error('Screenshot failed:', error);
    });
  setTimeout(() => {
     headerbar.classList.remove('highlight');
    document.querySelector('.main-chat-box').style.display="block";
  }, 1000);
})

window.addEventListener('load', function() {  
  // showLoader();
  fetch(`https://api.thehealthspanco.com/api/v1/diagnose/get/${hsID}`, requestOptions)
    .then((response) => {
      console.log('response')
      if (!response.ok) {
          throw new Error("Network response was not ok");
        }     
      return  response.json()
    })
    .then((result) => {
        let Height =Math.floor(result?.data?.height);
        let Activity = result?.data?.phyiscal_activity;
        age.innerText = result?.data?.age+" years";
        name.innerText = result?.data?.name;
       
        gender.innerText = result?.data?.gender;
        height.innerText = Height+" cm";
        weight.innerText = result?.data?.weight+" kgs";
        goal_weight.innerText = result?.data?.idealWeight+" kgs";
        bmi.innerText = result?.data?.bmi?.range+" ("+result?.data?.bmi?.category+")";
        bmr.innerText = result?.data?.bmr;
        allergic.innerText = result?.data?.allergic;
        console.log('allergic :',result?.data?.allergic);
        if (Activity === "light") {
            activity.innerText = "Sedentary Active";
        } else {
            activity.innerText = Activity + " Active";
        }
       //document.querySelector(".macronutrient-needs .section-title .user-name").innerText=result?.data?.name;
       let category = result?.data?.bmi?.category;
       let bodyMass = document.querySelectorAll(".bmi-status.body-mass")
       let bmi_text = document.querySelectorAll(".bmi-status.body-mass .bmi");
       bmi_text.forEach((item)=>{
         item.innerText = result?.data?.bmi?.range+" ";
       })
       if(category === "Normal"){
          bodyMass.forEach((item)=>{
            item.style.display="none";
          })
          let plan_item = document.querySelectorAll('.personalized-plan .Normal');
          plan_item.forEach((item)=>{
             item.style.display="block";
          })
          document.querySelector('.bmi-status.body-mass.Normal').style.display="block";
          document.querySelector('.Normal .normal').style.display="block";
      }
       if(category === "Overweight"){
           bodyMass.forEach((item)=>{
            item.style.display="none";
          })
          let plan_item = document.querySelectorAll('.personalized-plan .Overweight');
          plan_item.forEach((item)=>{
            item.style.display="block";
          })
          document.querySelector('.bmi-status.body-mass.Overweight').style.display="block";
          document.querySelector('.Overweight .overweight').style.display="block";
      }
      if(category === "Obese"){
           bodyMass.forEach((item)=>{
            item.style.display="none";
          })
          let plan_item = document.querySelectorAll('.personalized-plan .Overweight');
          plan_item.forEach((item)=>{
            item.style.display="block";
          })
          document.querySelector('.bmi-status.body-mass.Overweight').style.display="block";
          document.querySelector('.Overweight .overweight').style.display="block";
      }
       if(category === "Underweight"){
           bodyMass.forEach((item)=>{
            item.style.display="none";
          })
          document.querySelector('.recommendation-item.first ').style.display="none";
          document.querySelector('.next-steps .action-buttons .btn-primary ').style.display="none";
         document.querySelector('.recommendation-item.second .recommendation-icon').innerText="1";
         let plan_item = document.querySelector('.personalized-plan');
        console.log('plan_item ',plan_item);
        plan_item.style.display="none";
        document.querySelector('.bmi-status.body-mass.Underweight').style.display="block";
        document.querySelector('.Underweight .underweight').style.display="block";
      }
      console.log('category:',category);
      preference.innerText = result?.data?.eating_habits;
      
      tdee.innerText = result?.data?.tdee;
      rdc.innerText = result?.data?.rdc;
      protein.innerText = result?.data?.macronutrient?.protein?.grams +" grams";
      fat.innerText = result?.data?.macronutrient?.fat?.grams +" grams";
      carbs.innerText = result?.data?.macronutrient?.carbohydrates?.grams +" grams";
      water.innerText = result?.data?.macronutrient?.water?.liters +" liters";
      let tag = result?.data?.tag;
      console.log('Tag:',tag);
      let heading = document.querySelector('.kit-contents .product-heading');
       let planheading = document.querySelector('.personalized-plan h2');
       let save_price = document.querySelector('.personalized-plan .pricing-details .savings strong');
       let main_price = document.querySelector('.personalized-plan .pricing-details .final-price s');
       let final_price = document.querySelector('.personalized-plan .pricing-details .final-price strong');
       let rdc_box = document.querySelector('.personal-in .stats-container .stat-main-box.show-box');
      let sub_heading = document.querySelector('.personalized-plan .pricing-card .offer-tag');
      console.log('rdc_box:',rdc_box);
      let productCard = document.querySelectorAll('.kit-contents .products-grid .productCard');

      let journeySection = document.querySelector('.loss-journey');
      console.log('journeySection ',journeySection);
      if(tag == "Loss"){
        let loss = document.querySelectorAll('.kit-contents .products-grid .Loss');
        productCard.forEach((card)=>{
          card.style.display="none";
        })
        loss.forEach((item)=>{
          item.style.display="flex";
        })
        journeySection.style.display="block"
        buyNow.setAttribute('att', '49498616201514');
        heading.innerText = "Weight Loss kit";
         planheading.innerText = "Your 15 Days Kick starter Weight Loss Kit";
        sub_heading.innerText = "15 Days Kick starter Weight Loss Kit";
        save_price.innerText = "₹ 1550";
        main_price.innerText = "₹ 3549";
        final_price.innerText = "₹ 1999";
      }else if(tag === 'Maintain'){
        let maintain = document.querySelectorAll('.kit-contents .products-grid .Maintain');
        productCard.forEach((card)=>{
          card.style.display="none";
        })
        maintain.forEach((item)=>{
          item.style.display="flex";
        })
        buyNow.setAttribute('att', '49641828745514');
       heading.innerText = "Gut Health Kit";
      planheading.innerText = "Your 15 Days Kick Starter Wellness Plan";
         sub_heading.innerText = "15 Days Kick Starter Wellness Kit";
        save_price.innerText = "₹ 1949";
        main_price.innerText = "₹ 2948";
        final_price.innerText = "₹ 999";
        rdc_box.style.display="none";
        document.querySelector('.personalized-plan .plan-item.Normal .price.price5').innerText = "₹ 1398 ";

      }else{
        let gain = document.querySelectorAll('.kit-contents .products-grid .Gain');
        productCard.forEach((card)=>{
          card.style.display="none";
        })
        gain.forEach((item)=>{
          item.style.display="flex";
        })
        //buyNow.setAttribute('att', '49498616201514');
        heading.innerText = "Recommend Energy Dense Nutrition Mix and Gut Repair"
      }
    })
    .catch((error) => console.error(error));
  });

buyNow.addEventListener('click',()=>{
  let id = buyNow.getAttribute('att');
  console.log("Varinat id:",id);
  var formdata = {
    items: [{ id: id, quantity: 1,properties: {hsid: hsID }}],
  };
  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
   .then((response) => {
      return response.json();
    })
   .then((response) => {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formdata),
      })
       .then((response) => {
          return response.json();
        })
       .then((response) => {
        
          fetch(window.location.href)
           .then((response) => {
              return response.text();
            })
           .then((html) => {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, "text/html");
              var header = doc.querySelector("header");
              document.querySelector("header").innerHTML = header.innerHTML;
              console.log('Header:............... ',header);
              // Reload the cart-drawer element
              var cartDrawer = doc.querySelector("#cart-drawer");
              document.querySelector("#cart-drawer").innerHTML = cartDrawer.innerHTML;

              // Simulate a click on the cart link to open the cart drawer
              var cartLink = document.querySelector('a[aria-controls="cart-drawer"]');
              cartLink.click();
            });
          document.querySelectorAll('.buy-now-preloader').forEach((load)=>{
                load.style.display = 'none';
           })
        })   
          
       .catch((error) => {
          console.error("Error: ", error);
         });
    })
   
   .catch((error) => {
      console.error("Error: ", error);
     });

})



